import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import dayjs from 'dayjs';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import {db} from '../firebase-config'
import { collection, query, where, and, onSnapshot} from "firebase/firestore";
import { AppCTX } from '../data/AppContext';
import Container from '@mui/material/Container';



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SetAppointment({setNewAppointment, prospect}) {
  const {user, scheduleAppointment, teamData} = React.useContext(AppCTX);
  const [open, setOpen] = React.useState(false);
  const [day, setDay] = React.useState(dayjs());
  const [time, setTime] = React.useState(dayjs())
  const [selectedCloser, setSelectedCloser] = React.useState(null);
  const [appointments, setAppointments] = React.useState([])


  React.useEffect(() => {
    if(prospect!=null){
      setOpen(true)
      setSelectedCloser(null)
    }else{
      setOpen(false)
      setAppointments([])
      setDay(dayjs())
      setTime(dayjs())
    }
  },[prospect])

  React.useEffect(() => {
    if(selectedCloser!=null){
      let q = query(collection(db, "prospects"),and(where("closer", "==", selectedCloser), where("appointmentSet", "==", true)));
      const unsubscribe = onSnapshot(q, (snapshot) => {
          let update = [];
          snapshot.forEach((doc) => {
            update.push(doc.data())
          })
          console.log('appointments found for this closer', update);
          setAppointments(update)
        },
        (error) => {
          console.log(error)
          setAppointments([])
        }
      );
      return ()=>unsubscribe()
    }else if(teamData.members.length!=0){
      let defaultCloser =  teamData.members.filter(member => member.memberType==='closer')[0].name
      setSelectedCloser(defaultCloser)
    }
  },[selectedCloser, teamData])

  const handleSetAppointment = () => {
    scheduleAppointment(prospect, day, time, selectedCloser, setNewAppointment);
    setNewAppointment(null);
  };

  const renderAppointments = React.useMemo(() => {
    let filteredApts = appointments.filter(prospect => prospect.appointmentStart.slice(0,10) === dayjs(day).format('YYYY-MM-DD'))
    if(filteredApts.length===0){
      return(
        <p>no appointments today</p>
      )
    }else{
      return(
        <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
          {
            filteredApts.map((home, idx)=>{
              let title;
              if(home.owners.length===2){
                title= `${home.owners[0].name} & ${home.owners[1].name}`
              }else{
                title= `${home.owners[0].name}`;
              }
              let appointmentStart = dayjs(home.appointmentStart,'YYYY-MM-DDTHH:mm').format('LT')
              let appointmentEnd = dayjs(home.appointmentStart  ,'YYYY-MM-DDTHH:mm').add(2,'hour').format('LT');

              return(
                <div key={idx}>
                  <ListItem alignItems="flex-start">
                    <Box sx={{ width: '20%', mr:'20px' }}>
                      <Stack spacing={2}>
                        <Typography
                          sx={{ display: 'inline' }}
                          component="span"
                          variant="body2"
                          color="text.primary"
                        >
                          {appointmentStart}
                        </Typography>
                        <Typography
                          sx={{ display: 'inline' }}
                          component="span"
                          variant="body2"
                          color="text.primary"
                        >
                          {appointmentEnd}
                        </Typography>
                      </Stack>
                    </Box>
                    <ListItemText
                      primary={title}
                      secondary={
                        <React.Fragment>
                          <Typography
                            sx={{ display: 'inline' }}
                            component="span"
                            variant="body2"
                            color="text.primary"
                          >
                            Setter - {home.setter}
                          </Typography>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                  {idx===filteredApts.length-1?null:<Divider variant="inset" component="li" />}
                </div>
              )
            })
          }
        </List>
      )
    }
  },[day, appointments])
  
  const blockedTimes = (hour) => {
    let filteredApts = appointments.filter(prospect => prospect.appointmentStart.slice(0, 10) === dayjs(day).format('YYYY-MM-DD'));
    
    for (let i = 0; i < filteredApts.length; i++) {
        let appointmentStart = dayjs(filteredApts[i].appointmentStart, 'HH').format('LT');
        let appointmentEnd = dayjs(filteredApts[i].appointmentStart, 'HH').add(2, 'hour').format('LT');

        // Convert the input hour to a comparable format
        let inputHour = dayjs(hour, 'HH').format('LT');

        // Check if the input hour is between the start and end
        if (inputHour >= appointmentStart && inputHour < appointmentEnd) {
            return true; // Input hour is within the blocked time range
        }
    }

    return false; // Input hour is not within any blocked time range
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Dialog
        fullScreen
        open={open}
        onClose={() => setNewAppointment(null)}
        TransitionComponent={Transition}
      >
        <AppBar sx={{position: 'relative'}}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setNewAppointment(null)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Create an appointment
            </Typography>
          </Toolbar>
        </AppBar>
        <Container maxWidth="sm">
        <DateCalendar
          sx={{width:'100%'}}
          showDaysOutsideCurrentMonth
          fixedWeekNumber={6}
          views={['day']}
          value={day}
          onChange={(newVal)=>setDay(newVal)}
          minDate={dayjs()}
        />
        <List>
          <ListItem>
            <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label">Closer</FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={selectedCloser}
                onChange={(e) => setSelectedCloser(e.target.value)}
              >
                {teamData?.members?.map((member,idx) =>{
                  if(member?.memberType === 'closer'){
                    return(<FormControlLabel key={idx} value={member.name} control={<Radio />} label={member.name} />)
                  }
                })}
              </RadioGroup>
            </FormControl>
          </ListItem>
          <Divider />
          <ListItem >
            {renderAppointments}
          </ListItem>
          <Divider />
          <ListItem >
            <Box sx={{
                mt:'25px'
              }}
            >
              <Stack spacing={2}>
                <MobileTimePicker
                  label="Appointment Start Time"
                  defaultValue={time}
                  onChange={(newTime)=>setTime(newTime)}
                  // disablePast
                  // shouldDisableTime={(value, view) =>
                  //   view === 'hours' && blockedTimes(value.hour())
                  // }
                />
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  onClick={handleSetAppointment}
                >
                  Set Appointment
                </Button>
              </Stack>
            </Box>
          </ListItem>
        </List>
        </Container>
      </Dialog>
    </LocalizationProvider>
  );
}
